<app-page-heading [heading]="'Add a Master Drug'" [hasBackButton]="!isDialog" [tabName]="'master-drugs'"></app-page-heading>

<div *ngIf="isEdit && editMasterDrug.masterDrugId == null" class="center-container">
  <mat-spinner></mat-spinner>
</div>

<div class="stepper-container">
    <mat-horizontal-stepper #stepper [linear]="true">
        <mat-step [stepControl]="generalFormGroup" [completed]="generalFormGroup.valid">
            <ng-template matStepLabel>General</ng-template>
            <form [formGroup]="generalFormGroup">
                <mat-grid-list cols="2" rowHeight="75px">
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Master Drug Name</mat-label>
                            <input matInput type="text" [formControl]="drugNameFormControl"  required>
                        </mat-form-field>
                        <mat-icon class="info-icon" #drugNameTooltip="matTooltip" [matTooltip]="getInfoTooltip('Master Drug Name')">help_outline</mat-icon>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <greydom-date-picker
                            label="Start Date"
                            [required]="true"
                            [formControl]="startDateFormControl"
                            [tooltip]="getInfoTooltip('Start Date')"
                            [maxDate]="endDateFormControl.value">
                        </greydom-date-picker>
                    </mat-grid-tile>
                    <mat-grid-tile></mat-grid-tile>
                    <mat-grid-tile>
                        <greydom-date-picker
                            label="End Date"
                            [required]="true" 
                            [formControl]="endDateFormControl"
                            [tooltip]="getInfoTooltip('End Date')"
                            [minDate]="startDateFormControl.value">
                        </greydom-date-picker>
                    </mat-grid-tile>
                </mat-grid-list>
                <div *ngIf="!isDialog" class="button-container">
                    <button mat-raised-button color="warn" (click)="generalFormGroup.reset()">Clear</button>
                    <button mat-raised-button matStepperNext color="primary">Next</button>
                </div>
            </form>
        </mat-step>
        <mat-step [completed]="detailFormGroup.valid">
            <ng-template matStepLabel>Detail</ng-template>
            <form [formGroup]="detailFormGroup">
                <mat-grid-list cols="2" rowHeight="75px">
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Dosage Form</mat-label>
                            <mat-select name="dosageForm" [formControl]="dosageFormFormControl" required>
                                <mat-option *ngFor="let dosageForm of dosageForms" [value]="dosageForm.name">
                                    {{dosageForm.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-icon class="info-icon" #dosageFormTooltip="matTooltip" [matTooltip]="getInfoTooltip('Dosage Form')">help_outline</mat-icon>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Route of Administration</mat-label>
                            <input matInput type="search" [formControl]="routeOfAdminFormControl" [matAutocomplete]="routeAuto" (input)="filterRoutes()">
                            <mat-autocomplete #routeAuto="matAutocomplete">
                                <mat-option *ngFor="let route of filteredRoutes" [value]="route.name">
                                    {{route.name}}
                                </mat-option>
                            </mat-autocomplete>
                            <button mat-button mat-icon-button matSuffix  (click)="addRoute()">
                                <mat-icon style="color: grey;">add</mat-icon>
                            </button>
                        </mat-form-field>
                        <mat-icon class="info-icon" #routeOfAdminTooltip="matTooltip" [matTooltip]="getInfoTooltip('Route of Administration')">help_outline</mat-icon>
                    </mat-grid-tile>
                </mat-grid-list>
                <div formArrayName="routes">
                    <p *ngIf="routes.length < 1" class="form-array error-message">Select at least 1 Route of Admin</p>
                    <div class="form-array" *ngFor="let route of routes.controls; let i=index">
                        <mat-form-field style="width: 20vw">
                            <mat-label>Route {{i + 1}}</mat-label>
                            <input matInput [formControl]="routes.controls[i]" required/>
                            <span matSuffix><a style="cursor: pointer;" (click)="removeRoute(i)"><mat-icon>delete</mat-icon></a></span>
                        </mat-form-field>
                    </div>
                </div>
                <div *ngIf="!isDialog" class="button-container">
                    <button mat-raised-button matStepperPrevious color="primary">Back</button>
                    <button mat-raised-button color="warn" (click)="detailFormGroup.reset()">Clear</button>
                    <button mat-raised-button matStepperNext color="primary">Next</button>
                </div>
            </form>
        </mat-step>
        <mat-step [completed]="ingredientsFormGroup.valid">
            <ng-template matStepLabel>Ingredients</ng-template>
            <form [formGroup]="ingredientsFormGroup">
                <mat-grid-list cols="2" rowHeight="75px">
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Ingredient</mat-label>
                            <input matInput type="search" [formControl]="ingredientFormControl" [matAutocomplete]="ingredientAuto" (input)="filterIngredients()">
                            <mat-autocomplete #ingredientAuto="matAutocomplete">
                                <mat-option *ngFor="let ingredient of filteredIngredients" [value]="ingredient.name">
                                    {{ingredient.name}}
                                </mat-option>
                            </mat-autocomplete>
                            <button mat-button mat-icon-button matSuffix  (click)="addIngredient()">
                                <mat-icon style="color: grey;">add</mat-icon>
                            </button>
                        </mat-form-field>
                        <mat-icon class="info-icon" #ingredientTooltip="matTooltip" [matTooltip]="getInfoTooltip('Ingredient')">help_outline</mat-icon>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <p *ngIf="ingredients.length >= 1" class="column-label">Ingredient List:</p>
                        <p *ngIf="ingredients.length < 1" class="column-label error-message">Select at least 1 ingredient</p>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <button style="width: fit-content;" mat-raised-button color="accent" (click)="openIngredientDialog()">Add New Ingredient</button>
                    </mat-grid-tile>
                </mat-grid-list>
                <div>
                    <div formArrayName="ingredients">
                        <div class="form-array" *ngFor="let ingredientGrp of ingredients.controls; let j=index">
                            <ng-container [formGroup]="ingredientGrp">
                                <mat-form-field style="width: 15vw; padding-right: 1vw;">
                                    <mat-label>Ingredient {{j + 1}}</mat-label>
                                    <input matInput formControlName="ingredient" required/>
                                    <span matSuffix><a style="cursor: pointer;" (click)="removeIngredient(j)"><mat-icon>delete</mat-icon></a></span>
                                </mat-form-field>
                                <mat-form-field style="width: 4vw; padding-right: 1vw;">
                                    <mat-label>Strength</mat-label>
                                    <input matInput type="number" min="0" formControlName="strength" required/>
                                </mat-form-field>
                                <mat-form-field style="width: 4vw">
                                    <mat-label>Unit of Measure</mat-label>
                                    <mat-select name="unit" formControlName="unitOfMeasure" required>
                                        <mat-option *ngFor="let unit of unitsOfMeasure" [value]="unit.name">
                                            {{unit.name}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </ng-container>
                        </div>
                    </div>
                </div>
                <div *ngIf="!isDialog" class="button-container">
                    <button mat-raised-button matStepperPrevious color="primary">Back</button>
                    <button mat-raised-button color="warn" (click)="ingredientsFormGroup.reset()">Clear</button>
                    <button mat-raised-button color="primary" (click)="ingredientNext()">Next</button>
                </div>
            </form>
        </mat-step>
        <mat-step [completed]="atcFormGroup.valid">
            <ng-template matStepLabel>ATC Codes</ng-template>
            <form [formGroup]="atcFormGroup">
                <mat-grid-list cols="2" rowHeight="75px">
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>ATC Code</mat-label>
                            <input matInput type="search" [formControl]="atcCodeFormControl" [matAutocomplete]="atcAuto" (input)="filterAtcCodes()">
                            <mat-autocomplete #atcAuto="matAutocomplete">
                                <mat-option *ngFor="let atc of filteredAtcCodes" [value]="atc.name">
                                    {{atc.name}}
                                </mat-option>
                            </mat-autocomplete>
                            <button mat-button mat-icon-button matSuffix  (click)="addAtcCode()">
                                <mat-icon style="color: grey;">add</mat-icon>
                            </button>
                        </mat-form-field>
                        <mat-icon class="info-icon" #atcTooltip="matTooltip" [matTooltip]="getInfoTooltip('ATC Code')">help_outline</mat-icon>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <p *ngIf="atcCodes.length >= 1" class="column-label">ATC Code List:</p>
                        <p *ngIf="atcCodes.length < 1" class="column-label error-message">Select at least 1 ATC Code</p>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <button style="width: fit-content;" mat-raised-button color="accent" (click)="openAtcDialog()">Add New ATC</button>
                    </mat-grid-tile>
                </mat-grid-list>
                <div>
                    <div formArrayName="atcCodes">
                        <div class="form-array" *ngFor="let atcCodeGrp of atcCodes.controls; let k=index">
                            <ng-container [formGroup]="atcCodeGrp">
                                <mat-form-field style="width: 15vw; padding-right: 1vw;">
                                    <mat-label>ATC Code {{k + 1}}</mat-label>
                                    <input matInput formControlName="atcCode" required/>
                                    <span matSuffix><a style="cursor: pointer;" (click)="removeAtcCode(k)"><mat-icon>delete</mat-icon></a></span>
                                </mat-form-field>
                                <mat-form-field style="width: 4vw; padding-right: 1vw;">
                                    <mat-label>Ingredient</mat-label>
                                    <input matInput type="text" formControlName="ingredient" required/>
                                </mat-form-field>
                                <mat-form-field style="width: 4vw">
                                    <mat-label>Level</mat-label>
                                    <input matInput type="text" formControlName="level" required>
                                </mat-form-field>
                            </ng-container>
                        </div>
                    </div>
                </div>
                <div *ngIf="!isDialog"  class="button-container">
                    <button mat-raised-button matStepperPrevious color="primary">Back</button>
                    <button mat-raised-button color="warn" (click)="atcFormGroup.reset()">Clear</button>
                    <button mat-raised-button matStepperNext color="primary">Next</button>
                </div>
            </form>
        </mat-step>
        <mat-step editable="false">
            <ng-template matStepLabel>Finish</ng-template>
            <mat-grid-list cols="2" rowHeight="80px">
                <mat-grid-tile>
                    <div class="display-field">
                        <p class="label">Master Drug Name</p>
                        <p class="content">{{drugNameFormControl.value | slice:0:120}}</p>
                    </div>
                </mat-grid-tile>
                <mat-grid-tile>
                    <div class="display-field">
                        <a class="link" (click)="openDialog('Ingredients(s)')">Ingredient(s)</a>
                    </div>
                </mat-grid-tile>
                <mat-grid-tile>
                    <div class="display-field">
                        <p class="label">Dosage Form</p>
                        <p class="content">{{dosageFormFormControl.value}}</p>
                    </div>
                </mat-grid-tile>
                <mat-grid-tile>
                    <div class="display-field">
                        <a class="link" (click)="openDialog('Route(s) of Administration')">Route(s) of Administration</a>
                    </div>
                </mat-grid-tile>
                <mat-grid-tile>
                    <div class="display-field">
                        <p class="label">Start Date</p>
                        <p class="content">{{startDateFormControl.value | date: dateFormat}}</p>
                    </div>
                </mat-grid-tile>
                <mat-grid-tile>
                    <div class="display-field">
                        <a class="link" (click)="openDialog('ATC Code(s)')">ATC Code(s)</a>
                    </div>
                </mat-grid-tile>
                <mat-grid-tile>
                    <div class="display-field">
                        <p class="label">End Date</p>
                        <p class="content">{{endDateFormControl.value | date: dateFormat}}</p>
                    </div>
                </mat-grid-tile>
            </mat-grid-list>
            <form>
                <div *ngIf="!isDialog" class="button-container">
                    <button mat-raised-button matStepperPrevious color="primary">Back</button>
                    <button mat-raised-button matStepperPrevious color="warn" (click)="stepper.reset()">Clear</button>
                    <button mat-raised-button color="primary" (click)="finish()">Finish</button>
                </div>
                <div *ngIf="isDialog" align="center">
                    <div>
                        <button mat-raised-button color="warn" (click)="dialogRef.close()">Cancel</button>
                        <button mat-raised-button color="primary" (click)="finish()">Finish</button>
                    </div>
                </div>
            </form>
        </mat-step>
    </mat-horizontal-stepper>
</div>
